module.exports = __webpack_public_path__ + "static/media/vessel_default.ed65ef2d.webp";